'use strict';


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _state = require('@/libs/state');

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            closing: false
        };
    },

    computed: {
        backgroundStyle: function backgroundStyle() {
            var style = {};
            var options = _state2.default.settings.startupOptions;

            if (options.infoBackground) {
                style['background-image'] = 'url(' + options.infoBackground + ')';
            }
            return style;
        },
        backgroundImage: function backgroundImage() {
            return _state2.default.settings.startupOptions.infoBackground || '';
        },
        infoContent: function infoContent() {
            return _state2.default.settings.startupOptions.infoContent || '';
        }
    },
    methods: {
        close: function close() {
            var _this = this;

            this.closing = true;
            var startApp = function startApp(event) {
                _this.$el.removeEventListener('transitionend', startApp);
                _state2.default.persistence.watchStateForChanges();

                _this.$parent.$emit('start');
            };

            this.$el.addEventListener('transitionend', startApp, false);
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
if(!window._kiwi_exports["components"]["startups"]) window._kiwi_exports["components"]["startups"] = {};
window._kiwi_exports["components"]["startups"]["CommonLayout"]
window._kiwi_exports.components.startups.CommonLayout = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/startups/CommonLayout.vue
// module id = 7Ud/
// module chunks = 1